import styled from 'styled-components'

export const SparkSvg = styled.svg`
  display: block;
  flex: none;
  overflow: visible;
`
